import {
    createContext
} from "react";
import type {
    CommandDialogContextType,
    CommandContextType
} from "./type";

export const CommandContext = createContext<CommandContextType | undefined>(undefined);

export const CommandDialogContext = createContext<CommandDialogContextType | undefined>(undefined);
